module.exports = __webpack_public_path__ + "static/img/8.ca517f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/eng/8.png
// module id = dJQn
// module chunks = 0